import ApiService from "./ApiService";
export const apiService = new ApiService();
